import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Numbers4Stats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="nm4" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="nm4" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="nm4" />
    </>
  );
}
export default Numbers4Stats;